export default __webpack_public_path__ + "static/media/moneyAdministrator.706996ad.svg";